import React from 'react';
import { SnowflakeIcon, EyeOffIcon, MessageSquareOffIcon, UserXIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <SnowflakeIcon className="w-8 h-8 text-gold" data-id="element-104" />,
    text: 'Estás en el mismo lugar que ella, tienes la idea perfecta... pero el miedo al rechazo te congela. Observas cómo otro hombre se lleva la atención y la conversación. Te vas a casa con la misma frustración de siempre: sabiendo que pudiste ser tú, pero elegiste el silencio.'
  }, {
    icon: <EyeOffIcon className="w-8 h-8 text-gold" data-id="element-105" />,
    text: 'Te ves obligado a rebajar tus estándares y buscar atención en lugares donde realmente no quieres estar. Ves a las mujeres que verdaderamente te atraen como "fuera de tu liga" porque no logras captar su interés. Terminas conformándote con quien te da atención, no con quien tú realmente eliges, simplemente porque no tienes las herramientas de atracción para aspirar a más.'
  }, {
    icon: <MessageSquareOffIcon className="w-8 h-8 text-gold" data-id="element-106" />,
    text: 'Escribes un mensaje, lo lees diez veces, lo envías... y te dejan en visto. O peor: te responden con un "jaja sí" que mata cualquier conversación. Sientes que no sabes conectar.'
  }, {
    icon: <UserXIcon className="w-8 h-8 text-gold" data-id="element-107" />,
    text: 'Siempre terminas siendo "el buen amigo". Eres atento, respetuoso, interesante... pero nunca te ven como algo más. Y no entiendes qué estás haciendo mal.'
  }, {
    icon: <BrainIcon className="w-8 h-8 text-gold" data-id="element-108" />,
    text: 'Ves a otros hombres que no son más inteligentes ni más atractivos que tú, pero tienen algo que atrae a las personas como un imán. Y te preguntas: ¿qué tienen ellos que yo no?'
  }];
  return <section className="py-12 bg-surface-primary relative border-t border-surface-border" data-id="element-109">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="mb-12 max-w-3xl mx-auto rounded-2xl overflow-hidden border border-gold/20 shadow-2xl shadow-gold/5" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/sXKGSQU5tNrZaG1SbFDjJQ/3864ea0d-768a-43c2-8ff0-49f9fd6d1246.png" alt="Magnetismo y atracción en acción" className="w-full h-auto object-cover" data-id="element-112" />
        </div>

        <div className="text-center mb-10" data-id="element-113">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-114">
            ¿Te suena <span className="text-gold" data-id="element-115">familiar?</span>
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full mb-4" data-id="element-116"></div>
          <p className="font-body text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-117">
            Si marcaste aunque sea{' '}
            <span className="text-gold font-bold" data-id="element-118">UNO</span> de estos puntos...
            este protocolo fue diseñado exactamente para ti:{' '}
            <span className="text-white font-semibold" data-id="element-119">miedo al rechazo</span>,{' '}
            <span className="text-white font-semibold" data-id="element-120">estándares bajos</span>,{' '}
            <span className="text-white font-semibold" data-id="element-121">dejado en visto</span>,{' '}
            <span className="text-white font-semibold" data-id="element-122">la friendzone</span> o{' '}
            <span className="text-white font-semibold" data-id="element-123">sentirte invisible</span>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-124">
          {problems.map((problem, index) => <div key={index} className={`bg-surface-card p-8 rounded-xl border border-surface-border flex flex-col items-start ${index === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-125">
              <div className="p-3 bg-surface-elevated rounded-lg mb-6 border border-gold/20" data-id="element-126">
                {problem.icon}
              </div>
              {'title' in problem && problem.title && <h3 className="font-heading text-xl font-bold text-gold mb-3" data-id="element-127">
                  {problem.title}
                </h3>}
              <p className="font-body text-gray-300 text-lg leading-relaxed" data-id="element-128">
                {problem.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}